@if (isDefaultView) {
    <div class="country-info-view">
        @if (breakpointService.isDesktop()) {
            <div class="country-info-view__banner">
                <img role="presentation" [src]="bannerImgUrl | safeUrl" loading="lazy" alt="banner">
                <div class="country-info-view__top-info">
                    <p>{{ 'MAIN.TITLE' | translate }}</p>
                    <h1>{{ 'LOCATION.PLANT_TRIP_TO' | translate: {location: defaultLocationName | replaceStr: ' ' | titlecase} }}</h1>
                </div>
                <button class="btn-default btn-primary" (click)="planAPerfectTrip()" [disabled]="isFetching">
                    {{
                        'LOCATION.PLANT_TRIP_TO' | translate: {
                            location: defaultLocationName | replaceStr: ' ' | titlecase
                        }
                    }}
                </button>
            </div>
        } @else {
            <div class="country-info__header">
                <h1 class="country-info__label">
                    {{ defaultLocationName | replaceStr: ' ' | titlecase }} trip planner
                </h1>
                <div class="country-info__plan-trip">
                    <p>
                        Plan your trip to {{ defaultLocationName | replaceStr: ' ' | titlecase }} with RoutePerfect
                    </p>
                    <button class="btn-default btn-orange" (click)="planAPerfectTrip()">
                        Plan a Trip to {{ defaultLocationName | replaceStr: ' ' | titlecase }}
                    </button>
                </div>
            </div>
        }

        @if (isOnlyCountry) {
            <app-country-info-page
                    [isFetching]="isFetching"
                    [countryResponse]="countryResponse"
                    [countryDetails]="countryDetails"
                    [breadcrumbs]="breadcrumbs"
                    [defaultLocationName]="defaultLocationName"
            ></app-country-info-page>
        } @else if (isOnlyRegion) {
            <app-region-info-page
                    [isFetching]="isFetching"
                    [countryResponse]="countryResponse"
                    [countryDetails]="countryDetails"
                    [regionResponse]="regionResponse"
                    [regionDetails]="regionDetails"
                    [breadcrumbs]="breadcrumbs"
                    [defaultLocationName]="defaultLocationName"
            ></app-region-info-page>
        } @else if (isOnlyCity) {
            <app-city-info-page
                    [isFetching]="isFetching"
                    [countryResponse]="countryResponse"
                    [countryDetails]="countryDetails"
                    [regionResponse]="regionResponse"
                    [regionDetails]="regionDetails"
                    [cityResponse]="cityResponse"
                    [cityDetails]="cityDetails"
                    [breadcrumbs]="breadcrumbs"
                    [voiceMapResponse]="voiceMapResponse"
                    [categoriesResponse]="categoriesResponse"
                    [occasionGeniusResponse]="occasionGeniusResponse"
                    [defaultLocationName]="defaultLocationName"
            ></app-city-info-page>
        }
    </div>
} @else {
    <app-things-to-do></app-things-to-do>
}
